<template>
	<modal ref="modal">
		<template #title>{{action.toUpperCase()}} BCC CONTENT</template>
		<template #body>
			
					<div class="form-floating mb-4">
						<input type="text" v-model="form.category" id="category" name="category" class="form-control" placeholder="Category" />
						<label class="form-label" for="category">Category</label>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.title" id="title" name="title" class="form-control" placeholder="Title" />
						<label class="form-label" for="title">Title</label>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.vimeo_id" id="vimeo_id" name="vimeo_id" class="form-control" placeholder="Vimeo ID" />
						<label class="form-label" for="vimeo_id">Vimeo ID</label>
					</div>
					<div class="form-floating mb-4">
						<textarea v-model="form.description" id="description" class="form-control" placeholder="Enter Description" style="height:150px;"></textarea>
						<label class="form-label" for="description">Description</label>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.publish_by" id="publish_by" name="publish_by" class="form-control" placeholder="Publish By" />
						<label class="form-label" for="publish_by">Publish By</label>
					</div>
					<div class="form-floating mb-4">
						<flat-pickr
							v-model="form.date_start"
							id="date_start"
							name="date_start"
							class="form-control form-control-sm"
							:config="{
								altInput: true,
								altFormat: 'M j, Y',
								dateFormat: 'Y-m-d',
								wrap: true,
							}"
							placeholder="Date Start"
						/>
						<label class="form-label" for="date_start">Date Start</label>
					</div>
					<div class="form-group mb-4">
						<label class="form-label" for="status">Status</label>
						<div class="mt-2">
							<div class="form-check form-check-inline">
								<input
									v-model="form.status"
									id="status_on"
									name="status"
									class="form-check-input"
									type="radio"
									value="ON"
								/>
								<label class="form-check-label bg-alt-primary" for="ON">ON</label>
							</div>
							<div class="form-check form-check-inline">
								<input
									v-model="form.status"
									id="status_off"
									name="status"
									class="form-check-input"
									type="radio"
									value="OFF"
								/>
								<label class="form-check-label bg-alt-primary" for="OFF">OFF</label>
							</div>
						</div>
					</div>
				
		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Content</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}
		
		const action = ref('add');

		const form = useForm({
			sub_content_uuid: 0,
			sub_code 		: 'BCC',
			category 		: null,
			title 			: null,
			vimeo_id 		: null,
			description 	: null,
			publish_by 		: null,
			date_start 		: null,
			status 			: 'ON'
		})

		const actionContent = ()=>{

			if(action.value=='add')
			{
				addContent();
			}else
			{
				updateContent();	
			}

		}

		const addContent = () => {
			form.post(route('admin.post.bcc-content'), {
				preserveState: true,
				preserveScroll: true,
				only:['contents,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateContent = () => {
			form.put('bcc-content/'+form.sub_content_uuid, {
				preserveState: true,
				preserveScroll: true,
				only:['contents,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setBccContent = (_action,data)=>{
								
								form.reset();

								action.value = _action;

								if(_action=='update')
								{
									form.sub_content_uuid 	= data.sub_content_uuid;
									form.category 			= data.category;
									form.title 				= data.title;
									form.vimeo_id 			= data.vimeo_id;
									form.description 		= data.description;
									form.publish_by 		= data.publish_by;
									form.date_start 		= data.date_start;
									form.status 			= data.status;
								}
								
							}


		return {
			form,
			modal,
			toggleModal,
			action,
			setBccContent,
			actionContent,
			addContent,
			updateContent,
		}
	},
}
</script>
